import { styled } from '@fluentui/react';
import { GroupmeBrandedHeader } from '../presentationalComponents/GroupmeBrandedHeader';
import { getGroupmeBrandedHeaderStyles } from '../styles/groupmeBrandedHeaderStyles';


export const GroupmeBrandedHeaderContainer = styled(GroupmeBrandedHeader, getGroupmeBrandedHeaderStyles);
